<template><div><h1>VUX 能否在微信小程序里使用</h1>
<p>Sorry，不能。微信小程序是个相对封闭的平台，无法简单地适配也没有计划支持小程序版本。</p>
<p>目前企业主体用户可以使用 <code>web-view</code> 组件直接显示 web 页面，间接地使用 VUX。</p>
<h2>mpvue 解决方案能否直接迁移 VUX</h2>
<p>目前 <a href="http://mpvue.com/">mpvue</a> 还不支持 <code>slot</code>、<code>slot-scope</code>，因此迁移有难度，并且小程序存在较多差异，暂未计划。</p>
</div></template><script>
export default {
  head: {"title":"VUX 能否在微信小程序里使用 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// can-vux-used-in-weapp-49.vue?4050d332